export const sumAsync = async (source, selector) => {
    let sum = 0;
    for (const value of source) {
        sum += await selector(value);
    }
    return sum;
};
